export default __webpack_public_path__ + "static/media/padel-champions-thumbnail.c79e040a.png";